module.exports = __webpack_public_path__ + "img/fig34.a7692e18.jpg";